export default {
  toast_messages: {
    google_review_uploaded: 'Votre avis a été vérifié avec succès. Vous avez gagné {{points}} pts 😉',
  },
};
